module.exports = __webpack_public_path__ + "media/fonts/SFProText-Heavy-9420cd19f50ecc4058b5ab23bde626d8.eot";